/* istanbul ignore file */

import { LogicBuilderSet, LogicBuilderSetFormModel } from './logic-builder-set';
import { SiteEmailNotificationTriggered } from './site-email-notification-triggered';

class BaseLogicBuilder {
    active: boolean;
    createdById: string;
    createdByName: string;
    dateCreated: Date;
    description?: string;
    id: string;
    name: string;
    projectId: string;
    siteIds?: string[];
    siteEmailNotificationsTriggered?: SiteEmailNotificationTriggered[];
}

export class LogicBuilder extends BaseLogicBuilder {
    logicBuilderSets: LogicBuilderSet[];
}

export class LogicBuilderFormModel extends BaseLogicBuilder {
    logicBuilderSets: LogicBuilderSetFormModel[];
}
